<div class="a7-loading-content-container">
  <ng-content></ng-content>
</div>

<div #indicator
     class="a7-loading-indicator-container">
  <ng-content select="[a7-loading-indicator]"></ng-content>
</div>
